<template>
  <div class="release-note-component" @click="openNotificationsPage">
    <VdIcon store="fas" name="bell" />
    <el-badge is-dot class="badge" :hidden="!hasUnread" />
  </div>
</template>

<script lang="ts">
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import { computed, defineComponent, inject, Ref } from "vue";
import { RouteLocationRaw, useRouter } from "vue-router";

import { LAST_NOTIFICATION_ID_SEEN } from "@/constants";
import { useNotificationMenuItemQuery } from "@/graphql/generated-types";
import links from "@/router/links";

export default defineComponent({
  name: "NotificationsPage",

  components: {
    VdIcon,
  },

  setup() {
    const router = useRouter();
    const { result } = useNotificationMenuItemQuery();

    const lastNotificationId = computed(() => {
      const notificationIds = result.value?.notifications.map((notif) => notif.id) ?? [];
      if (notificationIds.length) {
        return notificationIds[0];
      }
      return "";
    });

    const lastNoficationIdSeen = inject<Ref<string>>(LAST_NOTIFICATION_ID_SEEN);

    const hasUnread = computed(() => lastNotificationId.value !== lastNoficationIdSeen?.value);

    const openNotificationsPage = () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const redirectTo: RouteLocationRaw = {
        name: links.releaseNotes,
        query: { back: router.currentRoute.value.fullPath },
      };
      router.push(redirectTo);
    };
    return { hasUnread, openNotificationsPage };
  },
});
</script>

<style lang="scss" scoped>
.release-note-component {
  text-emphasis: none;
  margin-right: size("M");
  position: relative;
  cursor: pointer;

  .badge {
    position: absolute;
    right: 1px;
  }

  .vd-icon {
    font-size: 20px;
  }
}
</style>
